import { render, staticRenderFns } from "./CampaignStepPromo.vue?vue&type=template&id=72110e6d&scoped=true"
import script from "./CampaignStepPromo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignStepPromo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CampaignStepPromo.vue?vue&type=style&index=0&id=72110e6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72110e6d",
  null
  
)

export default component.exports